import { useState, useEffect } from 'react';
import { SiteContent } from '../types';
import { fetchSiteContent } from '../data/dataFetch';

export const useSiteContent = () => {
  const [siteContent, setSiteContent] = useState<SiteContent | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadSiteContent = async () => {
      try {
        setError(null);
        const content = await fetchSiteContent();
        
        if (isMounted) {
          setSiteContent(content);
        }
      } catch (err) {
        console.error('Failed to load site content:', err);
        if (isMounted) {
          setError('Failed to load site content');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadSiteContent();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    siteContent,
    isLoading,
    error,
    refetch: () => {
      setIsLoading(true);
      setError(null);
      fetchSiteContent().then(setSiteContent).catch(setError).finally(() => setIsLoading(false));
    }
  };
};